import { getBadgeLevelDisplayLabel } from "@components/utils/normalizeBadgeLevel";

/**
 * Maps a badge removal `cause` (ER-10061) to the ReadinessBadge `view` value.
 * Cause enum: upgraded | awarded_in_good_standing | manually_removed |
 * expired | invalidated_by_checklist.
 */
const CAUSE_VIEW_MAP = {
  manually_removed: "Removed",
  invalidated_by_checklist: "Removed",
  expired: "Expired",
  upgraded: "Upgraded",
};

export function formatProficiencyBadgeView(cause) {
  if (!cause) {
    return "Editable";
  }
  return CAUSE_VIEW_MAP[cause] || cause.charAt(0).toUpperCase() + cause.slice(1);
}

const REMOVAL_CAUSES = ["manually_removed", "invalidated_by_checklist"];

/** Badge table "view" variant for a (non-current) badge row, from its cause. */
export function getBadgeViewFromCause(item) {
  if (item.is_current) {
    return "Editable";
  }
  if (item.cause === "upgraded") {
    return "Upgraded";
  }
  if (REMOVAL_CAUSES.includes(item.cause)) {
    return "Removed";
  }
  if (item.cause === "expired") {
    return "Expired";
  }
  return "Editable";
}

/** Upgraded-variant icon for a removed/expired badge row, from its cause. */
export function getUpgradedVariantIconFromCause(item) {
  if (!item.is_current && item.cause) {
    if (item.cause === "expired") {
      return "expired";
    }
    if (REMOVAL_CAUSES.includes(item.cause)) {
      return "removed";
    }
  }
  return null;
}

/** Resolve the display badge level label from a legacy/new label or numeric index. */
export function getBadgeLevelLabel(level) {
  return getBadgeLevelDisplayLabel(level);
}

/** ProficiencyBadge component props derived from a badge-bearing row. */
export function getProficiencyBadgeProps(obj) {
  return {
    level: getBadgeLevelLabel(obj?.badge?.level),
    dot: obj?.badge?.status,
    view: formatProficiencyBadgeView(obj?.badge?.cause),
    expiration_date: obj?.badge?.expiration_date,
    has_expiration_if_obsolete: obj?.badge?.expires_when_obsolete,
  };
}

/** Badge icon name for a given cause value. */
export function getBadgeIconNameFromCause(cause) {
  if (cause === "upgraded") {
    return "upgraded";
  }
  if (REMOVAL_CAUSES.includes(cause)) {
    return "removed";
  }
  if (cause === "expired") {
    return "expired";
  }
  return null;
}
